export default __webpack_public_path__ + "static/media/dog.1ea847b9.svg";